module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Airpods-42e1a7abd39e16da6b123b299984adbc.svg";